import styles from './styles.module.css';
import PropTypes from 'prop-types';

function KitoButton({ children, type = 'button', ...rest }) {
  return (
    <button className={styles.kitoButton} {...rest}>
      {children}
    </button>
  );
}

KitoButton.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  rest: PropTypes.objectOf({
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    hierarchy: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'icon']),
    variant: PropTypes.oneOf(['default', 'warning', 'danger', 'info', 'success']),
  }),
};

KitoButton.defaultProps = {
  rest: {
    onClick: () => {},
    disabled: false,
    hierarchy: 'primary',
    variant: 'default',
  },
};

export default KitoButton;
